import { combineReducers, Reducer } from 'redux'
import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { MessageTypes } from '@amzn/dvui/dist/Block'
import { createMergeReducer } from '../utils/reducer'
import { DetailPageActions, DetailPageActionTypes } from '../actions'
import { StringId } from '../components/localizer/stringId'

export type TitleIdToCrowBanner = {
  [titleId: string]: WpsTypes.atv.wps.BannerModelProps | undefined
}

export type UiBanner = {
  stringId?: StringId
  string?: string
  heading?: string
  type: MessageTypes
} | null

export type IBannerState = {
  crow: TitleIdToCrowBanner
  ui: UiBanner
}

const initialState = null as UiBanner

export const uiBannerReducer: Reducer<UiBanner, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.CreateBanner:
      return action.payload
    case DetailPageActionTypes.ClearBanner:
      return null
    default:
      return state
  }
}

export const reducer = combineReducers<IBannerState, DetailPageActions>({
  crow: createMergeReducer(t => t.banner && t.banner.crow, {} as TitleIdToCrowBanner),
  ui: uiBannerReducer,
})
